<div class="p-3" *ngIf="!loadingReserva; else spinner">
  <div class="mt-3 max-w-md mx-auto bg-white rounded-xl border border-gray-300 md:max-w-4xl p-3">
    <div class="flex justify-between items-center">
      <span class="text-xl font-bold text-gray-600">Reserva</span>
    </div>
    <div class="mt-1" >
        <reserva-info-view [reserva]="reserva"></reserva-info-view>
    </div>
  </div>

  <div *ngIf="!isReservaRascunho()" class="mt-3 max-w-md mx-auto bg-white rounded-xl border border-gray-300 md:max-w-4xl p-3">
    <span class="text-xl font-bold text-gray-600 pt-3" id="moradorPrincipal">Morador principal</span>
    <div *ngIf="show === 'principal'; else cardMoradorPrincipal">
      <app-personal-form [fichaCadastralMorador]="fichaCadastral.moradorPrincipal" (saveForm)="savePrincipalResident($event)"
        [allValidations]="true" [moradorPrincipal]="true"></app-personal-form>
    </div>
    <ng-template #cardMoradorPrincipal>
      <app-personal-view *ngIf="fichaCadastral?.moradorPrincipal?.pessoa?.nome" [pessoa]="fichaCadastral.moradorPrincipal.pessoa" (click)="canEditIfMoradorPrincipalIsLocatario()"></app-personal-view>
    </ng-template>
  </div>

  <div  *ngIf="!isReservaRascunho()" class="mt-3 max-w-md mx-auto bg-white rounded-xl border border-gray-300 md:max-w-4xl p-3">
    <span class="text-xl font-bold text-gray-600 pt-3 " id="locatario">Locatário</span>
    <app-personal-view *ngIf="fichaCadastral?.locatario?.nome" [pessoa]="fichaCadastral.locatario"
    ></app-personal-view>
  </div>

  <div class="mt-3 max-w-md mx-auto bg-white rounded-xl border border-gray-300 md:max-w-4xl p-3">
    <div class="flex justify-between items-center">
      <span class="text-xl font-bold text-gray-600">Moradores</span>
      <button class="btn btn-secondary" type="submit" [disabled]="disableButton()" (click)="addMorador()">Adicionar</button>
    </div>
    <div class="mt-4 border-t pt-4" *ngFor="let resident of fichaCadastral.demaisMoradores; let i = index">
      <div class="flex justify-between items-center">
        <span class=" text-xl font-bold text-gray-600" [id]="'resident'+i">Morador {{i + 1}}</span>
        <button class="btn btn-danger" type="submit" (click)="removeMorador(i)">Remover</button>
      </div>
      <app-personal-form [fichaCadastralMorador]="resident" (saveForm)="submitMorador($event, i)"
        *ngIf="show === 'resident'+i; else cardMorador" [allValidations]="false" [moradorPrincipal]="false"></app-personal-form>
      <ng-template #cardMorador>
        <app-personal-view [pessoa]="resident.pessoa" (click)="show = 'resident'+i"></app-personal-view>
      </ng-template>
    </div>
  </div>
  <div class="mt-3 max-w-md mx-auto bg-white rounded-xl border border-gray-300 md:max-w-4xl p-3">
    <div class="flex justify-between items-center">
      <span class="text-xl font-bold text-gray-600">Outras informações</span>
    </div>
    <div class="mt-3" >
      <others-info-form [fnrh]="fnrh" (saveFormFNRH)="submitFNRH($event)"
        *ngIf="showFnrhForm" (cancelForm)="changeFnrhVisibility()"></others-info-form >

        <others-info-view *ngIf="!showFnrhForm" (click)="changeFnrhVisibility()" [fnrh]="fnrh"></others-info-view>
    </div>
  </div>
  <div *ngIf="!sendingForm; else sending" class="mt-3 max-w-md mx-auto bg-white md:max-w-4xl">
    <button class="btn btn-primary w-full" type="submit" [disabled]="disableButton()" (click)="enviarFicha()">Enviar Ficha</button>
  </div>
  <ng-template #sending>
    <div class="flex justify-center mt-3">
      <div class="spinner"></div>
    </div>
  </ng-template>

</div>
<ng-template #spinner>
  <div class="flex justify-center">
    <div class="spinner"></div>
  </div>
</ng-template>
